import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = (id: number | string) => `${API_URL}/api/energy/devices/${id}`

const patchEcoModeDevice = (accessToken: string, id: number | string, data: Record<string, unknown>) => Axios.patch(ENDPOINT(id), data, {
  headers: { 'Access-Token': accessToken },
})

export default {
  patchEcoModeDevice,
}
